import styled from '@emotion/styled';
import OrganizationModel from '@shared/models/organizations/OrganizationModel';
import OrgBillingCard from './OrgBillingCard';
import OrgBillingErrorCard from './OrgBillingErrorCard';

interface OrgBillingComponentsProps {
    currentOrg: OrganizationModel;
    canManageBilling: boolean;
}

export default function OrgBillingComponents({ currentOrg, canManageBilling }: OrgBillingComponentsProps) {
    const showBilling =
        (canManageBilling && !currentOrg?.originatedByOrganizationId) ||
        (currentOrg?.originatedByOrganizationId && currentOrg?.customBillingUrl);

    return (
        <Row>
            {showBilling && <OrgBillingCard orgId={currentOrg.id} isLicensed={!!currentOrg.hasLicense} />}
            {canManageBilling && !showBilling && <OrgBillingErrorCard />}
        </Row>
    );
}

const Row = styled.div`
    margin: 1rem;
`;
